/*******************************************************************************
  Insights.js

  Author: Advait

*******************************************************************************/

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { API } from "aws-amplify";
import SelectTenant from "../components/SelectTenant";
import SelectSiteSimple from "../components/SelectSiteSimple";
import { selectSite } from "../store/siteSlice";
import "../index.css";

function Insights() {
  const isSysAdmin = useSelector((state) => state.user.sysAdmin);
  const selectedTenantId = useSelector((state) => state.selectedSite.tenantId);
  const selectedSiteId = useSelector((state) => state.selectedSite.siteId);
  const selectedSite = useSelector(selectSite);
  const [insightsData, setInsightsData] = useState(null);

  useEffect(() => {
    async function fetchInsightsDataForSite() {
      if (!selectedSiteId || !selectedSite || selectedSite.enablemonitoringdata !== true) {
        setInsightsData(null);
        return;
      }
      try {
        const endpoint = `/sites/${encodeURIComponent(selectedSiteId)}/insights`;
        const response = await API.get("fataskman", endpoint);
        console.log(`Insights data for site ${selectedSiteId}:`, response);
        setInsightsData(response || null);
      } catch (err) {
        console.error(`Error fetching insights data for site ${selectedSiteId}:`, err);
        setInsightsData(null);
      }
    }

    fetchInsightsDataForSite();
  }, [selectedSiteId, selectedSite]);

  function getMetricValue(durationKey, metricKey, fieldKey) {
    const value = insightsData?.[durationKey]?.[metricKey]?.[fieldKey];
    if (value === null || typeof value === "undefined") {
      return "No Data";
    }
    if (typeof value === "number" && Number.isFinite(value)) {
      return Math.round(value);
    }
    return value;
  }

  function renderMetricTable(metricKey) {
    const unit = metricKey === "WIFI" ? "dBm" : "dB(A)";
    return (
      <table className="insightTable">
        <thead>
          <tr>
            <th></th>
            <th>Last 30 Days</th>
            <th>Last 7 Days</th>
            <th>Yesterday</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Average {unit}</td>
            <td>{getMetricValue("30day", metricKey, "avg")}</td>
            <td>{getMetricValue("7day", metricKey, "avg")}</td>
            <td>{getMetricValue("yesterday", metricKey, "avg")}</td>
          </tr>
          <tr>
            <td>Max {unit}</td>
            <td>{getMetricValue("30day", metricKey, "max")}</td>
            <td>{getMetricValue("7day", metricKey, "max")}</td>
            <td>{getMetricValue("yesterday", metricKey, "max")}</td>
          </tr>
          <tr>
            <td>Min {unit}</td>
            <td>{getMetricValue("30day", metricKey, "min")}</td>
            <td>{getMetricValue("7day", metricKey, "min")}</td>
            <td>{getMetricValue("yesterday", metricKey, "min")}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <div className="fullPageDiv">
      <h3>Insights</h3>

      {isSysAdmin || !selectedTenantId ? <SelectTenant /> : null}

      {selectedTenantId ? <SelectSiteSimple /> : null}

      {selectedSiteId && selectedSite && selectedSite.enablemonitoringdata !== true ? (
        <div className="individualContainer">
          <table className="individualContainerTable">
            <tbody>
              <tr>
                <td valign="top" style={{ paddingLeft: "15px" }}>
                  <h4 style={{ width: "auto" }}>
                    Insights not activated. To activate, enable Passive Monitoring in System
                    Config.
                  </h4>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : null}

      {selectedSiteId && selectedSite && selectedSite.enablemonitoringdata === true ? (
        <>
          <div className="individualContainer" style={{ marginBottom: 0 }}>
            <table className="individualContainerTable">
              <tbody>
                <tr>
                  <td className="individualContainerTitleColumn" valign="top">
                    <h4 className="individualContainerTitleHeading">Wi-Fi</h4>
                  </td>
                  <td>{renderMetricTable("WIFI")}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="individualContainer" style={{ marginTop: 0 }}>
            <table className="individualContainerTable">
              <tbody>
                <tr>
                  <td className="individualContainerTitleColumn" valign="top">
                    <h4 className="individualContainerTitleHeading">Ambient Noise</h4>
                    <span
                      style={{
                        fontSize: "smaller",
                        color: "rgb(141, 150, 158)",
                        width: "190px",
                      }}
                    >
                      (From 12:00 AM to 3:00 AM)
                    </span>
                  </td>
                  <td>{renderMetricTable("NOISE")}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default Insights;
